<template>
    <v-card>
        <v-card-title>
            <v-btn icon small @click="close" color="primary">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
            <h3 class="ml-2">Delivery Exceptions</h3>
        </v-card-title>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="items"
                class="elevation-0"
                :mobile-breakpoint="0"
                disable-pagination
                hide-default-footer
                fixed-header
            >
                <template v-slot:[`item.Date`]="{ item }">
                    <p class="my-0">{{ formatDate(item.createdOn) }}</p>
                </template>
                <template v-slot:[`item.requestedQuantity`]="{ item }">
                    <p class="my-0 text-center">{{ item.requestedQuantity }}</p>
                </template>
                <template v-slot:[`item.maxQuantity`]="{ item }">
                    <p class="my-0 text-center">{{ item.maxQuantity }}</p>
                </template>
                <template v-slot:[`item.errors`]="{ item }">
                    <ul
                        class="my-0 pa-0"
                        style="list-style-type: disc; padding-left: 20px;"
                    >
                        <li
                            v-for="(error, index) in item.errors"
                            :key="index"
                            class="text-left"
                        >
                            {{ error }}
                        </li>
                    </ul>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import moment from 'moment'

export default {
    name: 'AssemblyPartnumbersExeption',
    props: {
        items: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data: () => ({
        headers: [
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
                width: '150',
            },
            {
                text: 'REQUESTED QTY',
                value: 'requestedQuantity',
                align: 'center',
                sortable: false,
                width: '120',
            },
            {
                text: 'MAX QTY',
                value: 'maxQuantity',
                align: 'center',
                sortable: false,
                width: '100',
            },
            {
                text: 'DESTINATION WORK ORDER',
                value: 'destinationWorkOrder',
                align: 'center',
                sortable: false,
                width: '180',
            },
            {
                text: 'ERRORS',
                value: 'errors',
                align: 'left',
                sortable: false,
                width: '300',
            },
            {
                text: 'DATE',
                value: 'Date',
                align: 'center',
                sortable: false,
                width: '120',
            },
        ],
    }),
    methods: {
        formatDate(date) {
            const seconds = date?.seconds || date?._seconds
            if (seconds) {
                return moment.unix(seconds).format('YYYY-MM-DD HH:mm')
            }
            return moment(date).format('YYYY-MM-DD HH:mm')
        },
        close() {
            this.$emit('closeDialog')
        },
    },
}
</script>
